var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialIconTwitterRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "background",
    fill: "#ffffff",
    d: "M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    fill: "#3d3d3d",
    d: "M22.69,12.57c0,0.15,0,.3,0,0.45A9.82,9.82,0,0,1,7.59,21.29a6.94,6.94,0,0,0,5.11-1.43,3.46,3.46,0,0,1-3.22-2.4,3.31,3.31,0,0,0,.65.06A3.39,3.39,0,0,0,11,17.4,3.45,3.45,0,0,1,8.26,14a0.29,0.29,0,0,1,0,0,3.41,3.41,0,0,0,1.56.43A3.45,3.45,0,0,1,8.76,9.79a9.8,9.8,0,0,0,7.11,3.61,3.46,3.46,0,0,1,5.88-3.15A6.83,6.83,0,0,0,24,9.41a3.47,3.47,0,0,1-1.52,1.91,6.89,6.89,0,0,0,2-.54,7,7,0,0,1-1.72,1.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "border",
    fill: "#3d3d3d",
    d: "M16,31.5C7.45,31.5,0.5,24.55,0.5,16S7.45,0.5,16,0.5S31.5,7.45,31.5,16S24.55,31.5,16,31.5z M16,1.5     C8,1.5,1.5,8,1.5,16S8,30.5,16,30.5S30.5,24,30.5,16S24,1.5,16,1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconTwitterRound);
export default __webpack_public_path__ + "static/media/social-icon-twitter-round.44922418533def110126e57c57c3f5cf.svg";
export { ForwardRef as ReactComponent };